import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TradeOrderSharedService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useCancelCsOrder = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: { transactionId: string; companyId: string }) => {
      return await handleRequest(
        TradeOrderSharedService.postApiAwardSettlementApiAppTradeOrderCancelOrderFromVendor(
          data.transactionId,
          data.companyId
        )
      );
    },
    {
      onSuccess: () => {
        toast.success(<ToastComponent label='Success' message='Order cancelled successfully.' />);
        void queryClient.invalidateQueries('getCsTransactionHistory');
        void queryClient.invalidateQueries('getCsSellItems');
        onSuccess?.();
      },
    }
  );
};

export default useCancelCsOrder;
